export enum ApplicationWidgetPlacement {
  Plugin = "plugin",
  Settings = "settings",
  FullScreen = "fullscreen",
}

export enum ApplicationProduct {
  HelpDesk = "helpdesk",
  LiveChat = "livechat",
}

export interface IApplicationWidget {
  id: string;
  placement: ApplicationWidgetPlacement;
  url: string;
  shortcut?: {
    initialState: string;
  };
  appSlug?: string;
}

export interface IApplicationIcons {
  small?: string;
  large?: string;
  title?: string;
}

export interface IApplication {
  id: string;
  name: string;
  slug: string;
  description?: string;
  elements: {
    widgets: IApplicationWidget[];
  };
  icons: IApplicationIcons;
  isService: boolean;
  hasSettingsHidden?: boolean;
  clientId?: string;
  publishedAt?: string;
  tutorialUrl?: string;
  ownerId?: string;
  directInstallUrl?: string;
  goToWebsiteUrl?: string;
}

export interface IWidget extends IApplicationWidget {
  appId: string;
  icon: string;
  name?: string;
  path?: string;
}
